import * as PIXI from 'pixi.js';
import GameConfig from '../../game/GameConfig';
import GameModel from '../../game/GameModel';
import {MapState} from '../../common/map/MapState';
import GameUtils from 'src/game/GameUtils';
import {Location} from '../../common/map/Location';

import Sprite = PIXI.Sprite;

export class HeldRenderer {
    private tiles: Map<string, Sprite> = new Map<string, Sprite>();
    private map: MapState;

    public setMap(map: MapState): void {
        if (map === this.map) return;
        this.map = map;
        this.redraw();
    }

    public redraw(): void {
        this.map.forEachTile(({x, y}) => {
            const key = new Location(x, y).toString();
            const tile = this.tiles.get(key);
            if (Boolean(tile) === (this.map.heldBy[y][x] !== -1)) return;
            if (tile) {
                GameModel.heldContainer.removeChild(tile);
                this.tiles.delete(key);
            } else {
                this.tiles.set(key, this.createSprite(x, y));
            }
        });
    }

    public clear(): void {
        this.tiles.forEach(tile => GameModel.heldContainer.removeChild(tile));
        this.tiles.clear();
    }

    private createSprite(x: number, y: number): Sprite {
        const texture = GameUtils.spriteTexture('tiles/water');
        const sprite = new Sprite(texture);
        sprite.position.set(x * GameConfig.tileSize, y * GameConfig.tileSize);
        sprite.scale.set(2, 2);
        sprite.alpha = 0.5;
        GameModel.heldContainer.addChild(sprite);
        return sprite;
    }
}

export const heldRenderer = new HeldRenderer();



// WEBPACK FOOTER //
// ./src/Pixi/map/HeldRenderer.ts